import {
  MessageCircle,
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Instagram,
} from "lucide-react";
import { Link } from "react-router-dom";
import {
  LOGO_WHITE_URL,
  WHATSAPP_URL,
  CONTACT_EMAIL,
  LINKEDIN_URL,
  INSTAGRAM_URL,
  PRIVACY_POLICY_PATH,
} from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      id="contato"
      data-testid="site-footer"
      className="relative pt-20 pb-8 text-white"
      style={{ background: "var(--buzas-navy)" }}
    >
      <div className="container-buzas">
        <div className="grid lg:grid-cols-12 gap-12 pb-12">
          {/* Column 1 — Branding (5 cols) */}
          <div className="lg:col-span-5">
            <img
              src={LOGO_WHITE_URL}
              alt="Buzas Laser Service"
              className="h-14 w-auto"
              data-testid="footer-logo"
              style={{
                mixBlendMode: "screen",
                objectPosition: "left center",
              }}
            />
            <p
              className="mt-6 text-[14px] leading-relaxed max-w-sm"
              style={{ color: "#CBD5E1" }}
            >
              Fabricação de componentes metálicos sob projeto para oficinas
              aeronáuticas, hangares e operações de aviação agrícola. Peças sob
              medida com precisão industrial e entrega confiável para manter
              sua operação ativa.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-cta"
              className="inline-flex items-center gap-2 mt-6 bg-[var(--buzas-red)] hover:bg-[var(--buzas-red-dark)] text-white text-[14px] font-bold rounded-md transition-all duration-200 hover:-translate-y-px"
              style={{ padding: "8px 20px" }}
            >
              <MessageCircle size={14} strokeWidth={2.2} />
              Falar no WhatsApp
            </a>
          </div>

          {/* Column 2 — Navigation (3 cols) */}
          <div className="lg:col-span-3">
            <p
              className="text-[12px] font-bold uppercase mb-5 text-white"
              style={{ letterSpacing: "1px" }}
            >
              Navegação
            </p>
            <ul className="space-y-3.5 text-[14px]">
              <li>
                <a
                  href="/#top"
                  data-testid="footer-nav-inicio"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  Início
                </a>
              </li>
              <li>
                <a
                  href="/#beneficios"
                  data-testid="footer-nav-beneficios"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  Benefícios
                </a>
              </li>
              <li>
                <a
                  href="/#sobre"
                  data-testid="footer-nav-sobre"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  Sobre
                </a>
              </li>
              <li>
                <a
                  href="/#cta"
                  data-testid="footer-nav-orcamento"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  Orçamento
                </a>
              </li>
              <li>
                <a
                  href="/#faq"
                  data-testid="footer-nav-faq"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 — Contact & Social (4 cols) */}
          <div className="lg:col-span-4">
            <p
              className="text-[12px] font-bold uppercase mb-5 text-white"
              style={{ letterSpacing: "1px" }}
            >
              Contato
            </p>
            <ul className="space-y-4 text-[14px]">
              <li className="flex items-start gap-3">
                <Phone
                  size={16}
                  className="text-[var(--buzas-red)] mt-0.5 shrink-0"
                />
                <a
                  href="tel:+551133858700"
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  +55 (11) 3385-8700
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail
                  size={16}
                  className="text-[var(--buzas-red)] mt-0.5 shrink-0"
                />
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid="footer-email"
                  className="hover:text-white transition-colors"
                  style={{ color: "#CBD5E1" }}
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin
                  size={16}
                  className="text-[var(--buzas-red)] mt-0.5 shrink-0"
                />
                <span
                  data-testid="footer-address"
                  style={{ color: "#CBD5E1" }}
                >
                  Rua Serra Redonda, 450 — Vila Industrial
                  <br />
                  São Paulo — SP, CEP 03244-150
                </span>
              </li>
            </ul>

            <div className="mt-8">
              <p
                className="text-[12px] font-bold uppercase mb-4 text-white"
                style={{ letterSpacing: "1px" }}
              >
                Redes
              </p>
              <div className="flex items-center gap-5">
                <a
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn Buzas"
                  data-testid="footer-linkedin"
                  className="text-white/75 hover:text-white transition-colors"
                >
                  <Linkedin size={20} strokeWidth={1.5} />
                </a>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram Buzas"
                  data-testid="footer-instagram"
                  className="text-white/75 hover:text-white transition-colors"
                >
                  <Instagram size={20} strokeWidth={1.5} />
                </a>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  aria-label="E-mail Buzas"
                  data-testid="footer-email-link"
                  className="text-white/75 hover:text-white transition-colors"
                >
                  <Mail size={20} strokeWidth={1.5} />
                </a>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp Buzas"
                  data-testid="footer-whatsapp-icon"
                  className="text-white/75 hover:text-white transition-colors"
                >
                  <MessageCircle size={20} strokeWidth={1.5} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="pt-6 flex flex-wrap items-center justify-between gap-4 text-[12px]"
          style={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            color: "rgba(203, 213, 225, 0.65)",
          }}
        >
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} Buzas Laser Service. Todos os
            direitos reservados.
          </p>
          <Link
            to={PRIVACY_POLICY_PATH}
            data-testid="footer-privacy-policy"
            className="hover:text-white transition-colors"
          >
            Política de Privacidade
          </Link>
          <p>
            Peças sob medida para aviação · Precisão industrial · Entrega
            confiável
          </p>
        </div>
      </div>
    </footer>
  );
}
